import type { IDtefComparisonCategory } from "@/@types/store-conciliation";

export const DTEF_CATEGORIES_ORDER: IDtefComparisonCategory[] = [
  "digital_wallet",
  "avenida_bill",
  "avenida_card",
  "third_party_cards",
];

export const DTEF_CATEGORY_LABELS_RESUME: Record<
  IDtefComparisonCategory,
  string
> = {
  digital_wallet: "Carteira digital",
  avenida_bill: "Fatura Avenida",
  avenida_card: "Cartão Avenida",
  third_party_cards: "Cartão Terceiros",
};

export const DTEF_CATEGORY_LABELS_WARNING: Record<
  IDtefComparisonCategory,
  string
> = {
  digital_wallet: "Carteira Digital",
  avenida_bill: "Fatura Avenida",
  avenida_card: "Cartão Avenida",
  third_party_cards: "Cartões Terceiros",
};

export const DTEF_DIVERGENCE_WARNING_TITLE = "Divergências DTEF";

export const DTEF_DIVERGENCE_WARNING_MESSAGE =
  "A conciliação pode ser fechada, porém foram identificadas divergências entre os valores do VAR e do DTEF. Revise os valores sinalizados antes de confirmar o fechamento.";

export const DTEF_COMPARISON_ROW_ARIA_DIVERGENT = "Divergência";

export const DIVERGENT_ICON_CLASSES = "h-4 w-4 text-red-600 shrink-0";

export const DTEF_RESUME_ROW_LABEL_SUFFIX = "DTEF";
